<!-- Consegna Digitale -->
<div class="ui-g-12">
  <form id="new-address-form" *ngIf="updatePersonalDataForm" [formGroup]="updatePersonalDataForm" [ngClass]="{'invalid-submit': invalidSubmit}">
    <!-- Email -->
    <div class="ui-g-12">    
      <div class="ui-g-4" style="text-align: right;">
        <span class="label">{{ 'reservations.emailAddress' | translate }}</span>
      </div>
      <div class="ui-g-8">
        <input pInputText type="email" formControlName="email" style="width: 100%;">
      </div>            
      <span class="input-error-notification" *ngIf="invalidSubmit && updatePersonalDataForm.controls['email'].errors?.email">{{ 'common.invalidMail' | translate }}</span>
    </div>
    <!-- Telefono -->
    <div class="ui-g-12">
      <div class="ui-g-4" style="text-align: right;">
        <span class="label">{{ 'reservations.phone' | translate }}</span>
      </div>
      <div class="ui-g-8">
        <input pInputText type="tel" formControlName="phone" style="width: 100%;">
      </div>      
      <span class="input-error-notification" *ngIf="invalidSubmit && updatePersonalDataForm.controls['phone'].errors?.phone">{{ 'common.invalidPhone' | translate }}</span>
    </div>
    <div class="ui-g-12">
      <span class="input-error-notification" *ngIf="invalidSubmit && (updatePersonalDataForm.controls['email'].errors?.required || updatePersonalDataForm.controls['phone'].errors?.required)">{{ 'common.atLeastOneRequired' | translate }}</span>
    </div>
    <!-- Button Aggiorna Dati Anagrafici -->
    <div class="ui-g-12" style="text-align: center;">
      <button
        pButton
        class="k-generic-btn"
        (click)="savePersonalData()"
        type="button"
        label="{{'reservations.updatePersonalData' | translate}}">
      </button>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/confirm-gift-reservation-form/update-personal-data-form/update-personal-data-form.component.html